import { FristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/FristenContext';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { useState } from 'react';

export function FristenContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [openEditSheet, setOpenEditSheet] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [fristIndex, setFristIndex] = useState<number>(0);
  const [openCreateSheet, setOpenCreateSheet] = useState(false);
  const [createSheetDefaultValues, setCreateSheetDefaultValues] = useState<{
    fristdatum: string | undefined;
    grund: FristenGrund | undefined;
    erinnerungsZeit: string[];
  }>({
    fristdatum: undefined,
    grund: undefined,
    erinnerungsZeit: [],
  });

  return (
    <FristenContext.Provider
      value={{
        openCreateSheet,
        setOpenCreateSheet,
        createSheetDefaultValues,
        setCreateSheetDefaultValues,
        openEditSheet,
        setOpenEditSheet,
        openDeleteDialog,
        setOpenDeleteDialog,
        fristIndex,
        setFristIndex,
      }}>
      {children}
    </FristenContext.Provider>
  );
}
